import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const DropdownCaret: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M13 1.46875L7 7.49468L1 1.46875" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg {...props} viewBox="0 0 16 9" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};